import React from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { Formik } from 'formik';
import Button from '../common/button';
import { useOneTimePassword } from './hooks';
import { Loader } from 'semantic-ui-react';
import GenericButton from '../../../Components/GenericButton/GenericButton';
import timerIcon from '../../img/Timer.svg';

const OneTimePassword = ({
  email,
  currentStep,
  nextStep,
  OTPExpiry,
  OTPLength,
  OTPAttempts,
}) => {
  const {
    schema,
    serverError,
    accountLocked,
    loader,
    maskEmail,
    validateOTP,
    generateOTP,
    setOneTimePassword,
    disabledContinueButton,
  } = useOneTimePassword({
    email,
    nextStep,
    OTPExpiry,
    OTPLength,
    OTPAttempts,
  });

  //need to check
  /*if ( serverError ) {
    return <Navigate to="/admin/server-error" push={true}></Navigate>;
  }
  // need to check
  if ( accountLocked ) {
    return <Navigate to="/admin/otp-error" push={true}></Navigate>;
  }*/

  return currentStep === 4 ? (
    <Col md={8} className="otp-verify-container otp-verify-container-box">
      <Row className="mb-4">
        <Col md={12}>
          <p>
            We have sent a One Time Password (OTP) to the email{' '}
            {maskEmail(email)}. Please enter it below.
          </p>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Formik
            validationSchema={schema}
            initialValues={{ oneTimePassword: '' }}
            onSubmit={(values, actions) => {
              //need to check
              actions.setStatus(undefined);
              validateOTP(values.oneTimePassword)
                .then(() => {
                  nextStep();
                  console.log('next step');
                })
                .catch((error) => {
                  actions.setStatus({
                    oneTimePassword: error,
                  });
                });
            }}
          >
            {({
              values,
              touched,
              errors,
              status,
              handleSubmit,
              handleChange,
              handleBlur,
              setStatus,
            }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-5">
                    <Form.Label className="mb-0">One time password</Form.Label>
                    <Form.Control
                      type="input"
                      name="oneTimePassword"
                      placeholder=""
                      className={
                        status && status.oneTimePassword ? 'is-invalid' : ''
                      }
                      value={values.oneTimePassword}
                      isInvalid={errors.oneTimePassword}
                      onChange={(e) => {
                        handleChange(e);
                        const setOTP = e.currentTarget.value.trim();
                        setOneTimePassword(setOTP);
                        setStatus({ oneTimePassword: '' });
                      }}
                      onBlur={(e) => {
                        handleBlur(e);
                        const setOTP = e.currentTarget.value.trim();
                        setOneTimePassword(setOTP);
                        setStatus({ oneTimePassword: '' });
                        console.log('status', status);
                        console.log('errors', errors);
                      }}
                    />
                    {status && status.oneTimePassword ? (
                      <Form.Control.Feedback type="invalid" className="mt-1">
                        <span>{status.oneTimePassword}</span>
                      </Form.Control.Feedback>
                    ) : (
                      errors.oneTimePassword && (
                        <Form.Control.Feedback type="invalid" className="mt-1">
                          <span>{errors.oneTimePassword}</span>
                        </Form.Control.Feedback>
                      )
                    )}
                    <p className="my-2">Enter OTP sent to you via email</p>
                  </Form.Group>
                  <Row>
                    <Col md={12} lg={8} sm={8}>
                      <span>
                        <img
                          className="timer-imag mr-2"
                          src={timerIcon}
                          alt="Timer"
                        />
                        <span className="timer-pading-left">
                          {'The OTP will expire in'}{' '}
                          <span id="otp-timer">05:00</span>
                          {' minutes'}
                        </span>
                      </span>
                      <h4 className="resend-code">
                        {' '}
                        Did not get it?
                        <button className="" onClick={generateOTP}>
                          Resend code.
                        </button>{' '}
                      </h4>
                    </Col>
                    <Col>
                      <GenericButton
                        type="submit"
                        variant="primary"
                        className="float-right"
                        disable={loader || disabledContinueButton}
                        buttonDisabled={disabledContinueButton}
                      >
                        Continue
                      </GenericButton>
                    </Col>
                  </Row>
                  {/*{loader && (
                      <div className="custom-loader mt-0 mt-md-3 mt-lg-4 d-flex justify-content-end">
                        <div className="loader-icon position-relative mr-4">
                          <Loader
                            className="text-dark font-weight-bold loader-color marginTop-Login-loader"
                            size="small"
                            active
                          />
                        </div>
                        <div className="text-dark font-weight-bold">Validating OTP...</div>
                      </div>
                    )} */}
                </Form>
              );
            }}
          </Formik>
        </Col>
      </Row>
    </Col>
  ) : null;
};

export default OneTimePassword;
